var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductT3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.04411 10.3646L8.12487 10.3646C9.26919 10.4067 10.18 11.3415 10.18 12.4854L10.18 37.3375C10.18 38.5069 9.22585 39.4598 8.04411 39.4598C6.86236 39.4598 5.90819 38.5069 5.90819 37.3375L5.90819 12.4869C5.90819 11.3162 6.86218 10.3646 8.04411 10.3646Z",
    fill: "url(#paint0_linear_7153_14017)",
    stroke: "white",
    strokeWidth: 0.99929
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3234 10.3641L37.4042 10.3641C38.5485 10.4062 39.4593 11.341 39.4593 12.4849L39.4593 37.337C39.4593 38.5064 38.5051 39.4593 37.3234 39.4593C36.1417 39.4593 35.1875 38.5064 35.1875 37.337L35.1875 12.4864C35.1875 11.3157 36.1415 10.3641 37.3234 10.3641Z",
    fill: "url(#paint1_linear_7153_14017)",
    stroke: "white",
    strokeWidth: 0.99929
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5114 8.41267L17.6 8.41267C18.8584 8.46473 19.9398 9.62072 19.9398 11.1424L19.9398 41.7688C19.9398 43.3244 18.807 44.5004 17.5114 44.5004C16.2157 44.5004 15.083 43.3244 15.083 41.7688L15.083 11.1442C15.083 9.58695 16.2156 8.41267 17.5114 8.41267Z",
    fill: "url(#paint2_linear_7153_14017)",
    stroke: "white",
    strokeWidth: 0.99929
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2711 0.604973L27.3576 0.604973C28.5775 0.662075 29.6996 1.92083 29.6996 3.67459L29.6996 37.5249C29.6996 39.3182 28.5237 40.5965 27.2711 40.5965C26.0186 40.5965 24.8427 39.3182 24.8427 37.5249L24.8427 3.67662C24.8427 1.88146 26.0184 0.604972 27.2711 0.604973Z",
    fill: "url(#paint3_linear_7153_14017)",
    stroke: "white",
    strokeWidth: 0.99929
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.50391 29.3838L42.4968 29.3838",
    stroke: "white",
    strokeWidth: 1.95204,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7153_14017",
    x1: 19.7458,
    y1: 3.01367,
    x2: 10.1207,
    y2: 37.2053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#ED1C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#53BCC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7153_14017",
    x1: 49.0251,
    y1: 3.01318,
    x2: 39.4,
    y2: 37.2048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#ED1C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#53BCC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7153_14017",
    x1: 30.5118,
    y1: -0.53008,
    x2: 17.5733,
    y2: 40.9048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#ED1C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#53BCC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7153_14017",
    x1: 40.2715,
    y1: -9.22653,
    x2: 24.771,
    y2: 35.6857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#ED1C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#53BCC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9B1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductT3);
export default __webpack_public_path__ + "static/media/product-t3.644368098d588862ddd1d43e9a19d926.svg";
export { ForwardRef as ReactComponent };